export default __webpack_public_path__ + "static/media/BTC.e2ab719f.svg";